module.exports = __webpack_public_path__ + "static/media/sushant_logo.17415044.png";